import { SvgIcon } from '@material-ui/core'

export const OneCIcon = props => (
  <SvgIcon {...props} style={{ fill: 'none' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M6.36366 6.36366V21.6363H2.54543V11.4546H0V7.63635H2.54543V6.36366H6.36366ZM18.8363 12.7273H22.7818C22.1454 9.16366 19.0909 6.36366 15.2727 6.36366C11.0727 6.36366 7.63634 9.80001 7.63634 14C7.63634 18.1148 10.9348 21.5008 15.0182 21.6363H28V17.8182H15.2727C11.6484 17.737 10.4424 13.7487 12.3703 11.494C14.278 9.27873 17.8845 9.98097 18.8462 12.7549"
        fill="#667085"
      />
    </svg>
  </SvgIcon>
)
